import React, {Component} from 'react';

export default class AccordionTrigger extends Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        this.props.handleClick(this.props.index);
    }

    render() {
        return (
            <header onClick={this.onClick}
                    aria-expanded={this.props.isActive}
                    className="accordion__trigger"
                    aria-controls={"accordion-content-" + this.props.index}
                    id={"accordion-header-" + this.props.index}>
                {this.props.content}
                <span className="accordion__icon" aria-hidden="true"></span>
            </header>
        );
    }
}